import { Service } from '@piwikpro/platform';

@Service()
export class UnauthorizedRequestError extends Error {
  name = 'UnauthorizedRequestError';

  errors = {};
}
